import { createContext, useEffect, useReducer } from "react";
// Services
import { appServices } from "../services/appServices";
// utils
import { changeFavicon } from "../utils/dynamicFavIcon"

const initialState = {
    isInitialized: false,
    appConfig: null
};

const handlers = {
    INITIALIZE: (state, action) => {
        const { isInitialized, appConfig } = action.payload;
        return {
            ...state,
            isInitialized,
            appConfig: appConfig ? appConfig : null
        };
    }
};

const reducer = (state, action) =>
    handlers[action.type] ? handlers[action.type](state, action) : state;

const AppConfigContext = createContext({ ...initialState });

function AppConfigProvider({ children }) {
    const [state, dispatch] = useReducer(reducer, initialState);
    useEffect(() => {
        const initialize = async () => {
            try {
                const clientOrigin = window.location.origin
                const response = await appServices.appConfig(clientOrigin);
                if (response == undefined) {
                    dispatch({
                        type: "INITIALIZE",
                        payload: {
                            isInitialized: true,
                        },
                    });
                } else if (response.data.status) {
                    const { appConfig } = response.data;
                    dispatch({
                        type: "INITIALIZE",
                        payload: {
                            isInitialized: true,
                            appConfig
                        },
                    });
                    if (appConfig.companyLogo != undefined) {
                        changeFavicon(appConfig.companyLogo.location)
                    }
                } else if (!response.data.status) {
                    dispatch({
                        type: "INITIALIZE",
                        payload: {
                            isInitialized: true,
                            appConfig: null
                        },
                    });
                }
            } catch (err) {
                console.error(err);
                dispatch({
                    type: "INITIALIZE",
                    payload: {
                        // Configuration is optional for rendering the app. Fall
                        // back to the default branding instead of leaving users
                        // on the loading screen after a network failure.
                        isInitialized: true,
                        appConfig: null
                    },
                });
            }
        };

        initialize();
    }, []);
    return (
        <AppConfigContext.Provider value={{ ...state }} >
            {children}
        </AppConfigContext.Provider>
    );
}

export { AppConfigContext, AppConfigProvider };
